<template>
  <div class="error-content">
    <p>
      您好，您当前暂时没有Eventplanning Dashboard看板权限。
      <br />
      若需申请用户权限，请说明个人所在部门，团队请发送申请邮件至：
      <br />
      zhifeng.wu.zw1@roche.com
      <br />
      待审批和赋权后即可登录系统
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.error-content {
  color: #f56c6c;
  background: #fee0e0;
  padding: 10px 0;
  text-align: center;

  p {
    line-height: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// ErrorSection.vue?29591618